import {useEffect, useState} from 'react';

import {formatWorkTimeDuration} from '../utils/formatWorkTimeDuration';

function getElapsedMinutes(startedAt?: string) {
  if (!startedAt) return 0;

  const startedAtTimestamp = new Date(startedAt).getTime();

  if (Number.isNaN(startedAtTimestamp)) return 0;

  return Math.max(Math.floor((Date.now() - startedAtTimestamp) / 60_000), 0);
}

export function useWorkTimeTimer(startedAt?: string) {
  const [elapsedMinutes, setElapsedMinutes] = useState(() =>
    getElapsedMinutes(startedAt)
  );

  useEffect(() => {
    setElapsedMinutes(getElapsedMinutes(startedAt));

    if (!startedAt) return;

    const interval = window.setInterval(() => {
      setElapsedMinutes(getElapsedMinutes(startedAt));
    }, 1000);

    return () => window.clearInterval(interval);
  }, [startedAt]);

  return formatWorkTimeDuration(elapsedMinutes);
}
